import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';

import { $Elements, Durations, Events } from './constants';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Carousel ----------

	//$('.content-section .section-carousel, .content-section .column-carousel').each(function() {

		//if(!this.swiper) {

			//const swiper = new Swiper(this, {
				//speed: Durations.animations.ms,
				//loop: true,
				//observer: true,
				//modules: [Navigation, Pagination],
				//pagination: {
					//el: this.querySelector('.swiper-pagination'),
				//},
				//navigation: {
					//nextEl: this.querySelector('.swiper-button-next'),
					//prevEl: this.querySelector('.swiper-button-prev'),
				//},
			//});
		//}
	//});

	// ---------- Wine Carousel ----------

	const swiperWine = () => {
		$('.wine-section .section-carousel').each(function() {
			if (!this.swiper) {
				if ($(window).width() < 1024) {
					this.swiper = new Swiper(this, {
						speed: Durations.animations.ms,
						loop: false,
						allowTouchMove: true,
						slidesPerView: "auto",
						modules: [Navigation, Pagination],

					});
				}
			} else {
				if ($(window).width() >= 1024) {
					this.swiper.destroy();
					this.swiper = null;
				}
			}
		});
	};

	swiperWine();

	window.addEventListener("resize", swiperWine);

	// ---------- Terroir carousel & history carousel ----------

	$('.terroirs-section .section-carousel, .history-section .section-carousel').each(function() {

	  if(!this.swiper) {

	    const swiper = new Swiper(this, {
	      speed: Durations.animations.ms,
	      loop: false,
		    slidesPerView: "auto",
	      modules: [Navigation, Pagination],
		  pagination: {
		    el: this.querySelector('.swiper-pagination'),
			  type: "progressbar",
		  },
	      navigation: {
	        nextEl: this.querySelector('.swiper-button-next'),
	        prevEl: this.querySelector('.swiper-button-prev'),
	      },
	   });
	 }
	});


	// ---------- Slideshow ----------

	$('.content-section .section-slideshow, .content-section .column-slideshow').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				loop: true,
				observer: true,
				autoplay: true,
				effect: 'fade',
				modules: [Autoplay, EffectFade, Navigation, Pagination],
				fadeEffect: {
					crossFade: true,
				},
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});
});
